<template>
  <div class="w-100">
    <TableBasic :payload="payload" @onChange="changeParameter" >
    <template v-slot:date="{data}">
        <div >
          {{ filters.dateSimple(data.created_date) }}
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
  import TableBasic from "@/components/TableBasic.vue";
  // import DatePicker from "@/components/DatePicker";
  export default {
    components: {
      TableBasic,
      // DatePicker
    },
    data() {
      return {
        payload: {
          filter: true,
          datepickerOption: {
            autoApply: true,
            timePicker: false,
          },
          filterLabel: "Filter by Registered date",
          header: [{
              key: "id",
              label: "SELLER ID",
              class: "text-justify",
              link: "/users/sellers"
            },
            {
              key: "store_name",
              label: "SELLER NAME",
              class: "text-justify",
            },
            {
              key: "paxel_username",
              label: "PAXEL USERNAME",
              class: "text-justify",
            },
            {
              key: "date",
              label: "REGISTERED DATE",
              class: "text-justify",
              sort_key : "created_date",
              sort: true
            }
          ],
          value: [],
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 20, 50, 100],
          search: true,
          startDate: "",
          endDate: "",
          searchPlaceholder: 'Seller Name/Phone, ID or Paxel Username',
        },
        filterValue: {}
      };
    },
    methods: {
      changeParameter(value) {
        this.payload.perPage = value.per_page
        this.payload.currentPage = value.current_page
        this.searchInput = value.search
        this.payload.sortType = value.sort_type
        this.payload.sortBy = value.sort_by
        this.filterValue = value.filter
        this.getData()
      },
      async getData() {
        let payload = {
          page: this.payload.currentPage,
          size: this.payload.perPage,
        }

        if (this.filterValue) {
          payload.date_start = this.filterValue.from
          payload.date_end = this.filterValue.to
        }

        if (this.searchInput != "") {
          payload.keyword = this.searchInput
        }

        if (this.sortBy != ""){
          payload.sort_by = this.payload.sortBy
          payload.sort_type = this.payload.sortType
        }
        try{
          const response = await this.$store.dispatch("seller/getAll", payload)
          this.payload.value = response.data.data.items
          this.payload.totalRows = response.data.data.count
        }catch(error){
          console.log("ERROR : ", error)
          this.$swal({
            title: error.response?.data ?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
        
      },
    },
    mounted() {
      this.getData()
    },
  };
</script>

<style></style>